// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  get(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("prescriptions/" + params.id + "/woods")
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data.woods);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  add(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("prescriptions/" + params.id + "/woods", params.model)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put(
        "prescriptions/" + params.prescriptionId + "/woods/" + params.id,
        params.model
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        })
        .finally(() => {
          context.commit("unset_loading");
        })
    });
  },

  delete(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.delete(
        "prescriptions/" + params.prescriptionId + "/woods/" + params.id
      )
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  quote(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put(
        "prescriptions/" +
          params.prescriptionId +
          "/woods/" +
          params.id +
          "/quote",
        params
      )
        .then(({ data }) => {
          console.log('resolve wood quote')
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  }
};
